import styled from 'styled-components';

import { metrics } from '@/theme';

export const Container = styled.div`
  margin-top: 80px;
  margin-bottom: 120px;
  display: flex;
  justify-content: center;
  @media (max-width: ${metrics.mobile}px) {
    margin: 10px 0 60px 0;
  }
`;

export const Form = styled.form`
  width: 630px;
  @media (max-width: ${metrics.mobile}px) {
    width: 100%;
  }
`;

export const FormFields = styled.div`
  margin-bottom: 50px;
`;
